export default __webpack_public_path__ + "static/media/darkmode.0f9192ae.png";